import PropTypes from "prop-types";
import React from "react";

import { positionShape } from "lib/propTypes";

import { getMismatchText } from "./util";

const ApplicationSummaryPosition = ({ activePIDs, position }) => {
    const applied = activePIDs.indexOf(position.id) > -1 ? " (Already applied)" : "";

    const mismatchText = getMismatchText(position);
    const mismatch = mismatchText ? (
        <span className="app-summary__position-mismatch">{mismatchText}</span>
    ) : null;

    return (
        <div className="app-summary__position">
            <div>
                {position.title} - {position.company_name}
                {applied}
            </div>
            {mismatch}
        </div>
    );
};

ApplicationSummaryPosition.propTypes = {
    activePIDs: PropTypes.arrayOf(PropTypes.number).isRequired,
    position: positionShape.isRequired,
};

export default ApplicationSummaryPosition;
